export default '/build/0a60c9dc.jpg'